import useChampionsQuery from "./useChampionsQuery";

export default function useChampion(championName, championID) {
  const { champions = [] } = useChampionsQuery();
  if (championName) {
    return champions.find((champion) => champion.name === championName);
  }
  if (championID) {
    return champions.find((champion) => champion.id === championID);
  }
  return undefined;
}
